import React from "react";
import { useModalContext } from "../../contexts/ModalContext/context";
import { IPlacementWorksheetUnit } from "../../services/PlacementWorksheetApi";
import { UnitManageModal } from "./UnitManageModal";
import { Button } from "../../UI/Button";

interface IProps {
  unit: IPlacementWorksheetUnit;
}

export const ManageButton: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();

  const openModal = () => setIsOpen(true);

  return (
    <>
      <Button onClick={openModal}>Manage</Button>
      <UnitManageModal unit={props.unit} />
    </>
  );
};
